<template>
  <li
    :class="classes"
    :tabindex="tabindex"
    @click="emit('click', $event)"
    @keydown="emit('keydown', $event)"
  >
    <slot name="prepend" />
    <div class="min-w-0 flex-1"><slot /></div>
    <slot name="append" />
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue'

/** UiListItem — Vuetify <v-list-item> replacement. */
const props = withDefaults(
  defineProps<{
    active?: boolean
    disabled?: boolean
    dense?: boolean
    tabindex?: number
  }>(),
  { active: false, disabled: false, dense: false },
)

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
  (e: 'keydown', event: KeyboardEvent): void
}>()

const classes = computed(() =>
  [
    'flex items-center gap-3 w-full text-left text-sm text-gray-800',
    props.dense ? 'px-2 py-1' : 'px-4 py-2',
    props.active ? 'bg-primary/10 text-primary' : 'hover:bg-gray-50',
    props.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
  ].join(' '),
)
</script>
